import { createSlice } from "@reduxjs/toolkit";
import { autoCompleteApiQuery } from "../Services/auto-complete.services";
// import { apiLocationBasedSearch } from "../Services/api.location.based.search";

type PayloadType = {};

type InitialStateType = {
  togglePropertyClaimedModal: boolean;
  /** The home already has a verified owner: the claim is a dispute (Oct 20 call). */
  claimModalAlreadyClaimed: boolean;
  recentlyAddedProperties: any;
  locationBased: any;
  state: any;
  city: any;
};

const initialState: InitialStateType = {
  togglePropertyClaimedModal: false,
  claimModalAlreadyClaimed: false,
  recentlyAddedProperties: null,
  locationBased: {},
  state: {},
  city: {},
};

type ActionType = {
  payload: PayloadType | any;
};

const propertyReducer = createSlice({
  name: "property",
  initialState,
  reducers: {
    // Payload: a property id (open), false (close), or
    // { propertyId, alreadyClaimed } to open it for a home someone else owns.
    setTogglePropertyClaimedModal: (
      state: InitialStateType,
      action: ActionType
    ) => {
      const p = action?.payload;
      if (p && typeof p === "object") {
        state.togglePropertyClaimedModal = p.propertyId;
        state.claimModalAlreadyClaimed = Boolean(p.alreadyClaimed);
      } else {
        state.togglePropertyClaimedModal = p;
        state.claimModalAlreadyClaimed = false;
      }
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      autoCompleteApiQuery.endpoints.getRecentlyAddedProperty.matchFulfilled,
      (state, action) => {
        state.recentlyAddedProperties = action.payload?.data;
        return state;
      }
    );
    builder.addMatcher(
      autoCompleteApiQuery.endpoints.getAllCityList.matchFulfilled,
      (state, action) => {
        state.city = action.payload?.data;
        return state;
      }
    );
    builder.addMatcher(
      autoCompleteApiQuery.endpoints.getAllStateList.matchFulfilled,
      (state, action) => {
        state.state = action.payload?.data;
        return state;
      }
    );

    builder.addMatcher(
      autoCompleteApiQuery.endpoints.getPropertyBasedOnLocation.matchFulfilled,
      (state, action) => {
        state.locationBased = action.payload;
        return state;
      }
    );
  },
});

export const { setTogglePropertyClaimedModal } = propertyReducer.actions;
export default propertyReducer.reducer;


